import { SpUser } from "../store/modules/user";
import axios, { AxiosResponse } from "axios";
import _ from "lodash";
import { BaseResponse } from "../apis";
import i18n from "../locale";
import store from "../store";
import util from "./util";
import { logout } from "../utils/logout";
import router from "../router";

// Flag to prevent multiple logout calls
let isLoggingOut = false;

axios.defaults.withCredentials = true;

axios.interceptors.request.use((config) => {
  const spUser = store.getters.spUser as SpUser;

  const { url, method } = config;
  if (
    (url.match(/\/api\/users\/check/) && method.toLowerCase() === "get") ||
    (url.match(/\/api\/auth\/session/) && method.toLowerCase() === "post") ||
    (url.match(/\/api\/auth\/v2\/check/) && method.toLowerCase() === "post")
  ) {
    config.headers["x-ms-token"] = spUser && spUser.token ? spUser.token : "";
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});


// intercepting responses
axios.interceptors.response.use((response: AxiosResponse<BaseResponse>) => {

  return response;
}, (error) => {
  if (error instanceof axios.Cancel) {
    return Promise.reject({});
  }
  // if (!error.response) {
  //   util.error(`<div class="tw-text-center">${i18n.t("message.service_unavailable")}</div>`);
  //   return Promise.reject({});
  // }

  if (error.response.status === 400 || error.response.status === 500) {
    const resp: BaseResponse = error.response.data;
    if (!_.isEmpty(resp)) {
      store.commit("API_MESSAGES_RESPONSE", _.groupBy(resp.messages, "field"));
    }
  }

  if (error.response.status === 403 && !isLoggingOut) {
    isLoggingOut = true;
    logout(store, router).then(() => {
      isLoggingOut = false;
    }).catch(() => {
      isLoggingOut = false;
    });
    return Promise.reject({});
  }

  return Promise.reject(error.response);
});
